/**
 * Default template configuration for memory books
 * Excludes special templates that sites can opt into via their config
 */

// Special templates that sites can opt into
export const SPECIAL_TEMPLATES = {
  CHINESE_SURNAME: 2,
  FAMILY_TREE: 16,
  GLOBAL_SURNAME: 17,
}

// Default templates available to all sites (excludes special templates)
export const DEFAULT_TEMPLATES = [0, 1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 18, 19]

export const getAllowedTemplates = (siteConfig = {}) => {
  const baseTemplates = [...DEFAULT_TEMPLATES]

  if (siteConfig.additionalTemplates && Array.isArray(siteConfig.additionalTemplates)) {
    // Add additional templates, avoiding duplicates
    const additionalTemplates = siteConfig.additionalTemplates.filter((template) => !baseTemplates.includes(template))
    baseTemplates.push(...additionalTemplates)
  }

  return baseTemplates.sort((a, b) => a - b) // Keep templates in order
}
